export default "__VITE_ASSET__DXn4P8VU__"